// src/utils/leadGuard.js
// Device-brede "al lead geweest"-vlag per funnel (localStorage, geen verloop).
// Voorkomt dat dezelfde persoon bij een tweede submit — ook dagen later of in
// een nieuwe sessie — opnieuw als lead wordt geteld in de Meta pixel en in het
// eigen dashboard. Aanvulling op emailCaptureGuard, die alleen de Make-webhook
// kortdurend (30s/24u) afschermt.

const PREFIX = 'lead_sent_';

export function hasSentLead(funnel) {
  try {
    return !!window.localStorage.getItem(PREFIX + funnel);
  } catch {
    return false;
  }
}

export function markLeadSent(funnel) {
  try {
    window.localStorage.setItem(PREFIX + funnel, String(Date.now()));
  } catch {}
}
